import { render, staticRenderFns } from "./ProformaDetail.vue?vue&type=template&id=331f9090&scoped=true&"
import script from "./ProformaDetail.vue?vue&type=script&lang=js&"
export * from "./ProformaDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProformaDetail.vue?vue&type=style&index=0&id=331f9090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331f9090",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('331f9090')) {
      api.createRecord('331f9090', component.options)
    } else {
      api.reload('331f9090', component.options)
    }
    module.hot.accept("./ProformaDetail.vue?vue&type=template&id=331f9090&scoped=true&", function () {
      api.rerender('331f9090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/agency/ProformaDetail.vue"
export default component.exports